var render = function render(){var _vm=this,_c=_vm._self._c;return _c('view-resolver',[_c('flagged-users-admin',{attrs:{"slot":"adminView"},slot:"adminView"}),_c('flagged-users-client',{attrs:{"slot":"clientView"},slot:"clientView"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }